import { useMemo } from 'react';

const yearColors = [
    "#DAD9D9", // Foundation (0)
    "#F8B449", // Year (1)
    "#1F43FF", // Year2 (2)
    "#795D0D", // Year3 (3)
    "#654B19", // Year4 (4)
    "#F57720", // Year5 (5)
    "#6B391C", // Year6 (6)
    "#0A093D", // Year7 (7)
    "#2D4433", // Year8 (8)
    "#2D4433", // Year9 (9)
    "#000000"  // Default for any other yearId (10 and beyond)
];

export function UseYearColor(yearId) {
    return useMemo(() => yearColors[yearId] || "#000000", [yearId]);
}
